import React, { useState, useEffect } from "react";
import AddNoteModal from "./AddNoteModal";
import { getOrderNote } from "../../redux/Orders/ordersAction";
import { useSelector, useDispatch } from "react-redux";
import { hasPermission } from "../../utils/permissionChecker";
import { PRIVILEGES } from "../../utils/privileges";

// Simple shimmer loader
const NoteShimmer = () => (
  <div className="mb-2 w-full flex flex-col border border-[#E1E6E1] rounded-md animate-pulse">
    <div className="h-4 bg-[#F6F7F6] rounded-t-md" />
    <div className="h-4 bg-[#F6F7F6]" />
    <div className="h-4 bg-[#F6F7F6] rounded-b-md" />
  </div>
);

const NoteSection = ({ id }) => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const { orderNotes, orderNotesLoading } = useSelector(
    (state) => state.orders
  );
  // Fetch user from the auth state if needed for permissions
  const { user } = useSelector((state) => state.auth);

  // Helper to format date/time
  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return {
      date: date.toLocaleDateString(),
      time: date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };
  };

  useEffect(() => {
    dispatch(getOrderNote({ id }));
  }, [dispatch, id]);

  return (
    <div className="w-[25%] ">
      <div>
        <div className="border border-[#E1E6E1] rounded-t-[8px] py-3 px-4 bg-white flex justify-between items-center">
          <p className="text-[#4B564D] font-semibold text-sm ">Notes</p>
          {hasPermission(user, PRIVILEGES.ADD_NOTE) && (
            <AddNoteModal
              show={showModal}
              setShow={setShowModal}
              notes={orderNotes || []}
              orderId={id}
            />
          )}
        </div>
        <div className="border-b border-r border-l border-[#E1E6E1] rounded-b-lg p-4 bg-white flex flex-col justify-center items-center max-w-[400px]">
          {/* Displaying the notes dynamically */}
          <div
            className="w-full overflow-y-auto"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            <style>{`.overflow-y-auto::-webkit-scrollbar{display:none}`}</style>
            {orderNotesLoading ? (
              // Show shimmer loaders while loading
              <>
                <NoteShimmer />
                <NoteShimmer />
                <NoteShimmer />
              </>
            ) : orderNotes && orderNotes.length > 0 ? (
              orderNotes.slice(0, 3).map((note, index) => {
                const { date, time } = formatDate(note.created);
                return (
                  <div
                    key={note.id}
                    className={`${
                      index < orderNotes.length - 1 ? "mb-2" : ""
                    }w-full overflow-hidden flex flex-col border border-[#E1E6E1] rounded-md`}
                  >
                    <div className="flex w-full bg-[#F6F7F6] justify-start text-left items-center border-b border-b-[#E1E6E1] p-2">
                      <p className="text-xs font-semibold text-[#3E473F]">
                        {note.title}
                      </p>
                    </div>
                    <div className="flex justify-start text-left items-center border-b border-b-[#E1E6E1] py-1 px-2">
                      <p className="text-xs font-semibold text-[#79887B]">
                        {note.text.length > 100
                          ? note.text.substring(0, 100) + "..."
                          : note.text}
                      </p>
                    </div>
                    <div className="flex justify-between text-left items-center  p-2">
                      <p className="text-xs font-semibold text-[#5F6D60]">
                        {note.created_by_name}
                      </p>
                      <p className="text-xs font-semibold text-[#5F6D60]">
                        {time}{" "}
                        <span className="text-base text-[#E1E6E1]">|</span>{" "}
                        {date}
                      </p>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="flex flex-1 flex-col items-center py-8 justify-center w-full h-full">
                <p className="text-[#5F6D60] font-semibold text-xs text-center">
                  You haven’t added any notes yet
                </p>
              </div>
            )}
          </div>
          {orderNotes && orderNotes.length > 3 && !orderNotesLoading && (
            <div className="flex items-center mt-2">
              <button
                onClick={() => setShowModal(true)}
                className="text-[#2B8C34] font-semibold text-xs text-left"
              >
                View More
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoteSection;
